import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioServicesCreateRequestDTO,
	postPortfolioServicesV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePostPortfolioServicesMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientPortfolioServicesCreateRequestDTO) =>
				postPortfolioServicesV2(requestContract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
		},
	});
};
